import {createActions} from 'client/framework';

const normalActions = [
  'SET_ASSESSMENT',
  'SET_ASSIGNMENT',
  'SET_ATTEMPT_NUMBER',
  'SET_CLASSROOM_ID',
  'SET_GUIDE_LEVEL',
  'SET_REPORT_TYPE'
];

export default createActions(null, normalActions);
